import * as React from "react";

import Column from "bulma/grid/Column";
import Columns from "bulma/grid/Columns";

export default () => (
    <Columns>
        <Column>
            <p>Please sign in.</p>
        </Column>
    </Columns>
);



// WEBPACK FOOTER //
// ./components/Programs/ProgramList/Warning.tsx